const Colors = {
    red: 'rgb(175,50,50)'
}

export default Colors
